import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-warehouse-transfer-status-badge',
    templateUrl: './warehouse-transfer-status-badge.component.html',
    styleUrls: ['./warehouse-transfer-status-badge.component.css']
})
export class WarehouseTransferStatusBadgeComponent implements OnInit {

    @Input() status: string;

    constructor() { }

    ngOnInit() {
    }

}

